import Logo from '../Logo/Logo';

export default Logo;